// extracted by mini-css-extract-plugin
export default {"column__text":"styles_column__text__gzxct"};